export default __webpack_public_path__ + "static/media/INPROCESS.72ad4da1.png";